export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8080',

  ENDPOINTS: {
    ACTIVITIES: '/api/activities',
    AUTH: '/api/auth',
    PARTICIPATIONS: '/api/participations',
    APPLICATIONS: '/api/applications',
    IMAGES: '/api/images',
    LOCATIONS: '/api/locations',
    INVITATIONS: '/api/invitations',
  },

  HEADERS: {
    'Content-Type': 'application/json',
  },
};
